import * as React from "react";
import {Link} from "react-router-dom";
import {DirectDebitDetailsSection} from "./DirectDebitDetailsSection";
import {resourcesHelper} from "@falcon/services";

interface IProps {
    policyNumber: string,
    interaction: any;
    haveActiveMandate: boolean
    mandate: any;
    annualToMonthly?: boolean;
    isRefundMandate?: boolean;
}

interface IState {
    mandate: any;
}

export class DirectDebitSection extends React.Component<IProps, IState> {


    constructor(props: any) {
        super(props);

        this.state = {
            mandate: this.props.mandate
        }
    }

    public render(): React.ReactNode {
        const {mandate} = this.state;
        const {haveActiveMandate} = this.props;
        const directDebitProcessLink = `/dashboard/${this.props.policyNumber}/paymentDetails/editDirectDebit/`;
        const buttonTheme = resourcesHelper.THEME === "ALLIANZ" ? "btn-white-dashboard" : "btn-primary";

        return (
            <div className="text-center mt-4 payment-details-section icon-direct-debit-before margin-top-0">
                {this.props.annualToMonthly &&
                    <div className="bubble-container">
                        <div className="corner-bubble">Renewal only</div>
                    </div>
                }
                <div className="dashboard-panel-title my-3">Direct Debit details</div>
                {this.props.isRefundMandate && <div className="d-flex section-panel banner banner-info">Heads up - these are the details we will use for any future refunds.</div>}
                <DirectDebitDetailsSection haveActiveMandate={haveActiveMandate} mandate={mandate}/>
                <div className="px-3 my-4 grid-col-2">
                    <Link
                        state={{annualToMonthly: this.props.annualToMonthly}}
                        to={directDebitProcessLink}
                        className={`btn ${buttonTheme} m-auto`}
                        id="editDirectDebit">
                        {haveActiveMandate ? 'Edit Direct Debit' : 'Set-up Direct Debit'}
                    </Link>
                </div>
            </div>
        )
    }
}
